/**
 * Общие утилиты синхронизации чата.
 *
 * Три панели чата (MessagesPane, ChatModal, InlineChatPanel) исторически
 * повторяют один и тот же код добавления/слияния сообщений, причём две из них
 * без дедупликации. Здесь одна реализация на всех.
 */

/** Ключ идемпотентности отправки. Сервер вернёт его обратно в сообщении. */
export function newClientUid() {
  try {
    if (typeof crypto !== 'undefined' && typeof crypto.randomUUID === 'function') {
      return crypto.randomUUID();
    }
  } catch (_) {}
  return `c-${Date.now()}-${Math.random().toString(36).slice(2, 10)}`;
}

/**
 * Вставить или обновить сообщение в списке.
 * Схлопывает по id, а если id ещё нет — по client_uid (оптимистичная копия).
 */
export function upsertMessage(list, msg) {
  if (!msg) return list;
  const arr = list || [];

  if (msg.id != null) {
    const byId = arr.findIndex((m) => m?.id === msg.id);
    if (byId !== -1) {
      const next = arr.slice();
      next[byId] = { ...next[byId], ...msg, _pending: false };
      return next;
    }
  }

  if (msg.client_uid) {
    const byUid = arr.findIndex((m) => m?.client_uid && m.client_uid === msg.client_uid);
    if (byUid !== -1) {
      const next = arr.slice();
      next[byUid] = { ...next[byUid], ...msg, _pending: false };
      return next;
    }
  }

  return [...arr, msg];
}

/** Слить пачку сообщений (догрузка, пагинация) без дублей. */
export function mergeMessages(list, incoming) {
  let out = list || [];
  (incoming || []).forEach((m) => { out = upsertMessage(out, m); });
  return out;
}

/** Максимальный известный id — отправная точка для догрузки по after_id. */
export function lastMessageId(list) {
  let max = 0;
  (list || []).forEach((m) => {
    const id = Number(m?.id);
    if (Number.isFinite(id) && id > max) max = id;
  });
  return max;
}